/* eslint-disable react/jsx-curly-newline */
/* eslint-disable object-curly-newline */
/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable react/prop-types */
/* eslint-disable no-else-return */
/* eslint-disable no-confusing-arrow */
/* eslint-disable arrow-body-style */
import React from 'react';
import { Navigate } from 'react-router-dom';
import DashboardLayout from 'src/components/DashboardLayout';
import MainLayout from 'src/components/MainLayout';
import Account from 'src/pages/Account';
import CustomerList from 'src/pages/CustomerList';
import Dashboard from 'src/pages/Dashboard';
import Home from 'src/pages/Home';
import Login from 'src/pages/Login';
import NotFound from 'src/pages/NotFound';
import Logout from 'src/pages/Logout';
import ProductList from 'src/pages/ProductList';
import Register from 'src/pages/Register';
import Settings from 'src/pages/Settings';
import Onboarding from 'src/pages/Onboarding';
import Assessment from './pages/Assessment';
import Clients from './pages/Clients';
import ClientUsers from './pages/ClientUsers';
import Tasks from './pages/Tasks';

const routes = (user, validSession) => [
  (() => {
    const userClientId = Number(user?.clientId ?? user?.client_id ?? 0);
    const isRestrictedUser = !!user && userClientId !== 3;
    const restrictedChildren = [
      { path: 'home', element: <Home /> },
      { path: 'assessment/*', element: <Assessment /> },
      { path: 'logout', element: <Logout /> },
      { path: '*', element: <Navigate to="/app/home" /> }
    ];
    const defaultChildren = [
      { path: 'home', element: <Dashboard /> },
      { path: 'assessment/*', element: <Assessment /> },
      { path: 'clients', element: <Clients /> },
      { path: 'users', element: <ClientUsers /> },
      { path: 'tasks', element: <Tasks /> },
      { path: 'onboarding', element: <Onboarding /> },
      { path: 'account', element: <Account /> },
      { path: 'customers', element: <CustomerList /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'products', element: <ProductList /> },
      { path: 'settings', element: <Settings /> },
      { path: 'logout', element: <Logout /> },
      { path: '*', element: <Navigate to="/404" /> }
    ];
    return {
      path: '/app',
      element: user && validSession ? <DashboardLayout /> : <Login />,
      children: isRestrictedUser ? restrictedChildren : defaultChildren
    };
  })(),
  {
    path: '/',
    element: <MainLayout />,
    children: [
      {
        path: 'login',
        element:
          !user && !validSession ? (
            <Login />
          ) : (
            <Navigate
              to={
                Number(user?.clientId ?? user?.client_id ?? 0) !== 3
                  ? '/app/home'
                  : '/app/dashboard'
              }
            />
          )
      },
      {
        path: 'register',
        element:
          !user && !validSession ? (
            <Register />
          ) : (
            <Navigate
              to={
                Number(user?.clientId ?? user?.client_id ?? 0) !== 3
                  ? '/app/home'
                  : '/app/dashboard'
              }
            />
          )
      },
      { path: '404', element: <NotFound /> },
      {
        path: '/',
        element:
          !user && !validSession ? (
            <Navigate to="/login" />
          ) : (
            <Navigate
              to={
                Number(user?.clientId ?? user?.client_id ?? 0) !== 3
                  ? '/app/home'
                  : '/app/dashboard'
              }
            />
          )
      },
      { path: '*', element: <Navigate to="/404" /> }
    ]
  }
];

export default routes;
